<div class="container" *ngIf="this.transactionData?.microProduct">
  <div class="row">
    <div class="col-sm col-md-6 col-lg-7">
      <div class="user-details">
        <h5>Hi {{ userName }}</h5>
        <span class="heading">Your order summary is mentioned below </span>
        <div class="d-flex contactinfo">
          <a
            class="email"
            target="_blank"
            href="mailto:{{ this.user?.user?.email }}"
            ><i style="margin-right: 5px" class="pi pi-envelope"></i
            >{{ userEmail}}</a
          >
          <a
            class="number"
            *ngIf="this.user?.user?.mobile !== 'undefined'"
            target="_blank"
            href="tel:+91{{ this.user?.user?.mobile }}"
            ><i style="margin-right: 5px" class="pi pi-phone"></i
            >{{ userMobile}}</a
          >
        </div>
      </div>
      <br /><br />

      <ng-container>
        <div *ngFor="let item of transactionData.items" class="itemwrap">
          <div class="bg-white">
            <div class="cart-item">
              <figure class="img-wrap">
                <span class="vname">{{ item.name | initials }}</span>
              </figure>
              <div class="card-text">
                <h2 class="item-title">
                  <span>{{ item.name }}</span>
                </h2>
                <span>{{ item.description }}</span>
              </div>
            </div>
            <div class="card-bottom">
              <span class="text-left price">{{ item.price | pricePipe }}</span>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
    <div class="col-sm col-md-6 col-lg-5">
      <div class="order-details bg-white">
        <h4 class="title">Order Details</h4>
        <div class="ids-wrapper">
          <div class="wrap-id d-flex">
            <span class="label-text">Order ID</span>
            <span class="id">{{ transactionData.razor_sub_id }}</span>
          </div>
          <div class="wrap-id d-flex">
            <span class="label-text">Transaction ID</span>
            <span class="id">{{ transactionData?.payment?.id }}</span>
          </div>
        </div>
        <ul class="list-items">
          <div *ngIf="transactionData">
            <li class="item-wrap d-flex label-wrap">
              <span class="label">Item(s) Total</span>
              <span class="label">{{
                totalAmountOfItems | gst : "-" | pricePipe
              }}</span>
            </li>
            <div *ngFor="let item of transactionData.items" class="itemlist">
              <span class="name">{{ item.name }}</span>
              <span>{{ item.price | gst : "-" | pricePipe }}</span>
            </div>

            <div class="gst">
              <span >Net Price</span><span>{{ totalAmountOfItems | gst : "-" | pricePipe }}</span>
            </div>
            <hr />
            <div class="gst">
              <span>18% GST</span>
              <span>{{ (totalAmountOfItems * 18) / 100 | pricePipe }}</span>
            </div>
          </div>
          <li class="item-wrap d-flex total-count">
            <span class="item-name">Grand Total</span>
            <span class="item-price">
              {{ totalAmountOfItems | pricePipe }}
            </span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>

<div class="container" *ngIf="!this.transactionData?.microProduct">
  <div class="row">
    <div class="col-sm col-md-8 col-lg-6">
      <div class="order-details bg-white" *ngIf="transactionData">
        <h4 class="title">Order Details</h4>
        <div class="ids-wrapper">
          <div class="wrap-id d-flex">
            <span class="label-text">Order ID</span>
            <span class="id">{{ transactionData.razor_sub_id }}</span>
          </div>
          <div class="wrap-id d-flex">
            <span class="label-text">Transaction ID</span>
            <span class="id">{{ transactionData.payment?.id }}</span>
          </div>
        </div>
        <ul class="list-items">
          <li class="item-wrap d-flex label-wrap">
            <span class="label">Item(s) Total</span>
            <span class="label">
              {{ transactionData.payment?.amount / 100 | pricePipe }}
            </span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
